import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IEndOfProductDesignWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IEndOfProductDesignWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  B2BEndOfProductSecondPage: any[];
  B2BEndOfProductSecondPage_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp689266Visible: "visible" | "hidden";
}

export class EndOfProductDesignWeb_ScreenBase extends React.PureComponent<
  IEndOfProductDesignWeb_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  endofproductdesignweb_746696_value_kuikaGalleryViewRef: React.RefObject<any>;
  endofproductdesignweb_822704_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 863498,
          PropertyName: "value",
          Value: "Koleksiyon Adı:",
          TagName: "Label12_value",
        },
        {
          Id: 818461,
          PropertyName: "placeholder",
          Value: "Desen Ara",
          TagName: "TextInput2_placeholder",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 863498,
          PropertyName: "value",
          Value: "Collection Name:",
          TagName: "Label12_value",
        },
        {
          Id: 818461,
          PropertyName: "placeholder",
          Value: "Search for Pattern",
          TagName: "TextInput2_placeholder",
        },
      ],
    },
    {
      Id: "a681c7f8-56e0-43ca-9393-1652625bc891",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 863498, PropertyName: "value", Value: "Koleksiyon Adı:" },
        { Id: 818461, PropertyName: "placeholder", Value: "Desen Ara" },
        {
          Id: 746696,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 689266,
          PropertyName: "value",
          Value: "[datafield:productattribute03description]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.endofproductdesignweb_818461_value_kuikaTextInputRef =
      React.createRef();
    this.endofproductdesignweb_746696_value_kuikaGalleryViewRef =
      React.createRef();
    this.endofproductdesignweb_822704_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      B2BEndOfProductSecondPage: [],
      NAVIGATE: "",
      SetValueOf: "",
      isComp689266Visible: "hidden",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "endofproductdesignweb",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.EndOfProductDesignWebPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.EndOfProductDesignWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "endofproductdesignweb",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "endofproductdesignweb",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.EndOfProductDesignWebPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.EndOfProductDesignWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  EndOfProductDesignWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductdesignweb_822704_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfProductDesignWeb/EndOfProductDesignWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BEndOfProductSecondPage =
      result?.data.b2BEndOfProductSecondPage;

    formVars.endofproductdesignweb_374226_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].productAttribute02Description
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EndOfProductDesignWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfProductDesignWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.endofproductdesignweb_374226_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].productAttribute02Description
        : null
    );

    stateVars.dataSource_746696 =
      stateVars.B2BEndOfProductSecondPage ??
      this.state.B2BEndOfProductSecondPage;
    formVars.endofproductdesignweb_822704_total = ReactSystemFunctions.value(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].totalRowCount
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EndOfProductDesignWebComponent_374226_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/endofproductcollectionweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EndOfProductDesignWeb",
      "EndOfProductCollectionWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfProductDesignWebComponent_102911_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfProductDesignWeb/EndOfProductDesignWebComponent_102911_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BEndOfProductSecondPage =
      result?.data.b2BEndOfProductSecondPage;

    formVars.endofproductdesignweb_374226_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].productAttribute02Description
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfProductDesignWebComponent_102911_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfProductDesignWebComponent_102911_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "endofproductdesignweb_822704_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.endofproductdesignweb_374226_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].productAttribute02Description
        : null
    );

    stateVars.dataSource_746696 =
      stateVars.B2BEndOfProductSecondPage ??
      this.state.B2BEndOfProductSecondPage;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfProductDesignWebComponent_922622_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/endofsproductfourthweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "EndOfSProductFourthWeb",
      "ProductAttribute02",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofproductdesignweb_746696_value",
          "productAttribute02"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EndOfSProductFourthWeb",
      "ProductAttribute03",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofproductdesignweb_746696_value",
          "productAttribute03"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EndOfSProductFourthWeb",
      "ColorCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofproductdesignweb_746696_value",
          "colorCode"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EndOfProductDesignWeb",
      "EndOfSProductFourthWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfProductDesignWebComponent_822704_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductdesignweb_822704_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductAttribute02_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      filtre_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "endofproductdesignweb_818461_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageSize_0: ReactSystemFunctions.convertToTypeByName(10, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfProductDesignWeb/EndOfProductDesignWebComponent_822704_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BEndOfProductSecondPage =
      result?.data.b2BEndOfProductSecondPage;

    formVars.endofproductdesignweb_374226_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].productAttribute02Description
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfProductDesignWebComponent_822704_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfProductDesignWebComponent_822704_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.endofproductdesignweb_374226_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].productAttribute02Description
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].productAttribute02Description
        : null
    );

    stateVars.dataSource_746696 =
      stateVars.B2BEndOfProductSecondPage ??
      this.state.B2BEndOfProductSecondPage;
    formVars.endofproductdesignweb_822704_total = ReactSystemFunctions.value(
      this,
      stateVars.B2BEndOfProductSecondPage !== undefined
        ? stateVars.B2BEndOfProductSecondPage?.length > 0
          ? stateVars.B2BEndOfProductSecondPage[0].totalRowCount
          : null
        : this.state.B2BEndOfProductSecondPage?.length > 0
        ? this.state.B2BEndOfProductSecondPage[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.EndOfProductDesignWebPageInit();
    }
  }
}
